import type { ApiFactorAnswer, ApiFactorCategory, ApiFactorDef, ApiIndustry, ApiRiskBand } from './api-types'

export enum AgentStatus {
  Live = 'live',
  ComingSoon = 'coming-soon',
}

export enum AgentTab {
  Chat = 'chat',
  Settings = 'settings',
  Alerts = 'alerts',
  History = 'history',
}

export enum AgentVersionState {
  Live = 'live',
  Saved = 'saved',
  Superseded = 'superseded',
}

export type AgentDef = {
  id: string
  label: string
  description: string
  icon: import('lucide-react').LucideIcon
  status: AgentStatus
  disabled?: boolean
}

export type FlagSource = 'eu' | 'fatf' | 'eu-fatf' | 'manual'

export type CountryBand = 'low' | 'medium' | 'high' | 'very-high'

export type Country = {
  code: string
  name: string
  band: CountryBand
  edd: boolean
  eddSource?: FlagSource
  prohibited: boolean
  prohibitedSource?: FlagSource
  emoji: string
}

export type FactorImpact = 'lr' | 'mr' | 'hr' | 'vhr'

export type FactorAnswer = ApiFactorAnswer
export type Factor = ApiFactorDef
export type FactorCategoryKey = 'customer' | 'geographical' | 'service' | 'delivery'
export type FactorCategory = ApiFactorCategory
export type RiskBandDef = ApiRiskBand
export type IndustryRisk = 'high-risk' | 'prohibited'
export type Industry = ApiIndustry
